import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/** Scrolls the window to the top on client-side navigation. */
export function ScrollToTop() {
  const { pathname, search } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname, search])

  return null
}
